<div class="header__burger-menu burger-menu" dropdown dropdownOpenClass="is-open">
  <button class="burger-menu__toggle btn" type="button" aria-label="menu" dropdownToggle>
    <div class="icon icon_bars-lite"></div>
  </button>

  <div class="burger-menu__content" dropdownContent>
    <a
      class="burger-menu__link burger-menu__link_bonus-wheel link"
      routerLink="/bonus-wheel"
      routerLinkActive="is-active"
    >
      <i class="icon icon_bonus-wheel"></i>
      <ng-container i18n="@@header.bonus-wheel_title"> Барабан Призов </ng-container>
    </a>

    <a class="burger-menu__link link" routerLink="/bonuses" routerLinkActive="is-active">
      <span class="icon icon_ticket-bold"></span>
      <ng-container i18n="@@header.bonuses">Бонусы</ng-container>
    </a>

    <a class="burger-menu__link link" routerLink="/referrals" routerLinkActive="is-active">
      <i class="icon icon_parthership-bold"></i>
      <ng-container i18n="@@header.referrals">Партнерство</ng-container>
    </a>

    <button type="button" class="burger-menu__link link intercomTrigger">
      <i class="icon icon_support-alt"></i>
      <ng-container i18n="@@header.support">Поддержка</ng-container>
    </button>

    @if (authState.user()) {
      <button class="burger-menu__logout" (click)="logout()">
        <span>Выход</span>
        <i class="icon icon_logout"></i>
      </button>
    }
  </div>
</div>
